const nl = {
  // Coach Landing Page (New Home)
  coachLanding: {
    tagline: 'Het platform dat sportcoaches verbindt met sporters in hun buurt',
    discoverMotivya: 'Ontdek Motivya',
    // Animated Pitch Scenes
    scene1Text: 'Ben je coach of fitness trainer?',
    scene1Subtext: 'Brussel heeft je nodig',
    scene2Text: 'Moe van het zoeken naar klanten?',
    scene2Subtext: 'Geen papierwerk en administratie meer',
    scene3Text: 'Heb je 4+ uur per week?',
    scene3Subtext: 'Genereer extra inkomen',
    scene4Text: 'Jij plant, Motivya doet de rest',
    scene4Subtext: 'Deelnemers komen automatisch',
    scene5Text: 'Focus op je passie',
    scene5Subtext: 'Nul papierwerk • Automatische klanten • Lokale impact',
    selectedBadge: 'Je bent geselecteerd om Ambassadeur te worden',
    ambassadorSpots: 'ambassadeursplaatsen',
    inBrussels: 'in Brussel',
    reservedSpots: 'Gereserveerde plaatsen',
    onlyRemaining: 'Nog maar {count} plaatsen beschikbaar!',
    ctaButton: 'Word Ambassadeur Coach',
    discoverMore: 'Ontdek de voordelen',
    whyJoin: 'Waarom Motivya?',
    advantagesTitle: 'Alle voordelen van ambassadeur coach zijn',
    advantagesSubtitle: 'Sluit je aan bij de eerste 90 oprichters-coaches en geniet van exclusieve levenslange voordelen',
    zeroRisk: 'Nul risico',
    zeroRiskDesc: 'Je stelt een minimale deelnemersdrempel in. Niet bereikt? De sessie wordt kosteloos geannuleerd.',
    commissionHalved: 'Commissie ÷ 2',
    commissionHalvedDesc: 'Als ambassadeur is je commissie levenslang gehalveerd (10% in plaats van 20%).',
    clientsProvided: 'Klanten geleverd',
    clientsProvidedDesc: 'Motivya verspreidt je sessies naar sporters in jouw zone. Klanten komen naar jou.',
    flexibleSchedule: 'Flexibel rooster',
    flexibleScheduleDesc: 'Maak sessies wanneer en waar je wilt. Je bent je eigen baas.',
    guaranteedIncome: 'Gegarandeerd inkomen',
    guaranteedIncomeDesc: 'Automatische betaling na elke sessie. Geen facturatie, geen administratie.',
    founderStatus: 'Oprichtersstatus',
    founderStatusDesc: 'Maximale zichtbaarheid vanaf de lancering. De beste tijdslots zijn voor jou.',
    howItWorksTitle: 'Hoe werkt het?',
    step1Title: 'Maak je profiel aan',
    step1Desc: 'In 2 minuten, presenteer je specialiteiten en ervaring.',
    step2Title: 'Publiceer je sessies',
    step2Desc: 'Stel locatie, tijd, prijs en minimaal aantal deelnemers in.',
    step3Title: 'Ontvang je betalingen',
    step3Desc: 'Boekingen komen binnen, de sessie vindt plaats, je wordt automatisch betaald.',
    finalCtaTitle: 'Klaar om je bedrijf te starten?',
    finalCtaSubtitle: 'Sluit je aan bij de oprichters-coaches van Motivya en laat je klantenbestand moeiteloos groeien.',
    freeNoCommitment: 'Gratis inschrijving • Zonder verplichting • Validatie binnen 48u',
  },

  nav: {
    explore: 'Ontdekken',
    becomeCoach: 'Word Coach',
    login: 'Inloggen',
    register: 'Start',
    dashboard: 'Dashboard',
    admin: 'Admin',
    logout: 'Uitloggen',
    coach: 'Coach',
    profile: 'Profiel',
    favorites: 'Favorieten',
    outfit: 'Outfit',
  },

  sessions: {
    join: 'Inschrijven',
    viewAll: 'Alle sessies bekijken',
    viewCoachSessions: 'Bekijk sessies',
  },

  landing: {
    // New hero messaging
    heroTitle: 'Sport in je buurt begint hier.',
    heroSub: 'Ontdek en neem deel aan',
    intention: 'sportactiviteiten',
    in: 'bij jou',
    action: 'in de buurt',
    heroDesc: 'Neem vandaag nog deel aan sportsessies bij jou in de buurt.',
    searchPlaceholder: 'Waar wil je sporten?',
    search: 'Zoeken',
    nearMe: 'Vind een sessie',
    allActivities: 'Ontdek alle activiteiten',
    sessionsStartingIn3h: 'sessies in de komende 3 uur in',
    startingSoonTitle: 'Binnenkort in je buurt',
    sessions: 'Sessies',
    coaches: 'Coaches',
    avgRating: 'Gemiddelde score',
    // Activities nearby section
    nearbyTitle: 'Activiteiten in de buurt',
    nearbySubtitle: 'Doe nu mee aan een sessie',
    joinSession: 'Deelnemen',
    participants: 'deelnemers',
    peopleParticipating: 'mensen nemen al deel',
    // Weekly sessions section
    weeklyTitle: 'Wekelijkse sportafspraken',
    weeklySubtitle: 'Bouw je wekelijkse routine',
    everyWednesday: 'Elke woensdag',
    everySaturday: 'Elke zaterdag',
    everySunday: 'Elke zondag',
    participateThisWeek: 'Deze week meedoen',
    // Category section
    findActivity: 'Wat er gebeurt',
    activity: 'bij jou in de buurt vandaag',
    findActivityDesc: 'Van ochtendyoga tot intensieve training: ontdek activiteiten die bij jou passen',
    allActivities: 'Bekijk alle activiteiten',
    // Features section
    whyMotivya: 'Waarom',
    whyMotivyaDesc: 'Motivya verbindt coaches en sporters in jouw buurt.',
    // Coach section
    youAreCoach: 'Ben je',
    coachWord: 'Coach',
    coachSubtitle: 'Bouw je lokale sportgemeenschap.',
    coachSubtext: 'Trek deelnemers uit je buurt aan en vul je sessies.',
    becomePartner: 'Word Coach Partner',
    coachBlock1Title: 'Terugkerend inkomen',
    coachBlock1Text: 'Nieuw terugkerend inkomen, zonder gedoe.',
    coachBlock2Title: 'Klanten dichtbij',
    coachBlock2Text: 'Klanten vlakbij. Minder verplaatsingen, meer sessies.',
    coachBlock3Title: 'Nooit verlies',
    coachBlock3Text: 'Minimumdrempel bereikt = sessie bevestigd.',
    // Social proof
    socialProof: 'Al honderden sessies georganiseerd in Brussel.',
    // Dynamic stats
    totalParticipants: 'Deelnemers',
    coachesIn: 'Coaches in',
    sessionsThisWeek: 'Sessies deze week',
    joinCommunity: 'Word lid van de community',
    // Real-time indicators
    sessionsStartingIn3h: 'sessies beginnen de komende 3 uur in',
    participantsToday: 'sporters nemen vandaag deel aan sessies',
    // Starting soon section
    urgentLabel: 'Begint binnenkort!',
    startingSoonTitle: 'Sessies die binnenkort beginnen',
    startingSoonSubtitle: 'Mis deze activiteiten niet die de komende uren starten',
    startsIn: 'Begint over',
    today: 'Vandaag',
    // Featured coaches section
    coachesNearbyTitle: 'Coaches in jouw buurt',
    coachesNearbySubtitle: 'Ontdek actieve coaches bij jou in de buurt',
    sessionsOrganized: 'sessies',
    totalParticipantsCoach: 'deelnemers',
    viewCoachSessions: 'Bekijk sessies',
    // Communities section
    communitiesTitle: 'Sportgemeenschappen in Brussel',
    communitiesSubtitle: 'Sluit je aan bij een groep en train regelmatig',
    members: 'leden',
    joinCommunityBtn: 'Sluit je aan',
    joinedCommunity: 'Je bent lid geworden van de community!',
    // Map section
    activitiesAroundYou: 'Activiteiten in je buurt',
    filterToday: 'Vandaag',
    filterTonight: 'Vanavond',
    filterWeek: 'Deze week',
    filterNearby: 'Dichtbij',
    mapRadiusInfo: 'Cirkel van 2 km rond je locatie • Klik op "Lokaliseer mij" op de kaart om te centreren',
    // Popular activities
    popularActivities: 'Populaire activiteiten',
    // Coaches section
    neighborhoodCoaches: 'Buurtcoaches',
    activeCoachesNear: 'Actieve coaches in de buurt van',
    allCoaches: 'Alle coaches',
    viewSessions: 'Bekijk sessies',
    // Communities section
    sportsCommunities: 'Sportgemeenschappen',
    joinGroupRegularly: 'Sluit je aan bij lokale groepen om regelmatig te trainen',
    joinGroup: 'Sluit je aan',
    // Coach CTA section
    developCommunity: 'Ontwikkel je lokale sportgemeenschap',
    joinMotivy: 'Sluit je aan bij Motivya en maak van je passie een bloeiende business',
    fillSessions: 'Vul je sessies',
    findNearbyAthletes: 'Vind sporters in je buurt',
    createRecurringIncome: 'Creëer terugkerende inkomsten',
    becomePartnerCoach: 'Word partnercoach',
    // Stats section
    activeParticipants: 'Actieve deelnemers',
    certifiedCoaches: 'Gecertificeerde coaches',
    sessionsThisWeekLabel: 'Sessies deze week',
    coveredMunicipalities: 'Gedekte gemeenten',
    // Newsletter section
    receiveSessionsNearYou: 'Ontvang sessies in je buurt',
    beNotifiedNewSessions: 'Word op de hoogte gebracht van nieuwe sessies in je buurt',
    yourEmail: 'Je e-mail',
    subscribeBtn: 'Inschrijven',
    thankYouSubscribed: 'Bedankt! Je bent ingeschreven.',
    // Footer
    footerExplore: 'Ontdekken',
    footerRegister: 'Registreren',
    footerCoach: 'Word Coach',
    footerActivities: 'Activiteiten',
    footerLegal: 'Juridisch',
    footerPrivacy: 'Privacy',
    footerTerms: 'Voorwaarden',
    footerContact: 'Contact',
    footerLocation: 'Brussel, België',
    footerSlogan: 'Sport in je buurt',
    allRightsReserved: 'Alle rechten voorbehouden.',
  },

  // Community subscription
  community: {
    title: 'Word lid van de Motivya community',
    subtitle: 'Ontvang meldingen over nieuwe sessies bij jou in de buurt op basis van je sportvoorkeuren.',
    emailPlaceholder: 'Je e-mailadres',
    subscribe: 'Inschrijven',
    selectPreferences: 'Kies je favoriete activiteiten (optioneel)',
    privacyNote: 'We respecteren je privacy. Je kunt je op elk moment uitschrijven.',
    subscribed: 'Welkom bij de community!',
    subscribedDesc: 'Je ontvangt binnenkort de beste sessies bij jou in de buurt.',
    subscribeSuccess: 'Succesvol ingeschreven! Welkom bij de Motivya community.',
    subscribeError: 'Fout bij inschrijven. Probeer het opnieuw.',
    emailRequired: 'Voer je e-mailadres in.',
  },

  features: {
    quickBooking: 'Bliksemreservering',
    quickBookingDesc: '2-3 klikken en het is geboekt. Simpel. Snel. Effectief.',
    nearby: 'Dichtbij',
    nearbyDesc: 'Vind activiteiten op een steenworp afstand dankzij geolocatie.',
    trust: 'Vertrouwen',
    trustDesc: 'Gecertificeerde coaches beoordeeld door een betrokken community.',
    flexibility: 'Flexibiliteit',
    flexibilityDesc: 'Regelmatige of eenmalige sessies, zoals jij het wilt.',
  },

  categories: {
    all: 'Alle',
    yoga: 'Yoga',
    renforcement: 'Krachttraining',
    mobilite: 'Mobiliteit',
    outdoor: 'Outdoor',
    running: 'Running',
    cardio: 'Cardio',
    pilates: 'Pilates',
    boxe: 'Boksen',
    danse: 'Dans',
    padel: 'Padel lessen',
    tennis: 'Tennis lessen',
  },

  explore: {
    objectiveTitle: 'Wat is jouw doel vandaag?',
    personalize: 'Personaliseer mijn ervaring',
    findActivity: 'Vind jouw activiteit',
    cityPlaceholder: 'Stad of postcode (bijv: 1050, Elsene, Schaarbeek...)',
    category: 'Categorie',
    level: 'Niveau',
    priceMax: 'Max. prijs (€)',
    clear: 'Wissen',
    apply: 'Toepassen',
    loading: 'Laden...',
    sessions: 'sessies',
    session: 'sessie',
    resetFilters: 'Filters resetten',
    noResults: 'Geen sessies gevonden',
    noResultsDesc: 'Probeer je zoekcriteria aan te passen',
    clearFilters: 'Filters wissen',
    showing: 'Eerste 50 sessies van',
    confirmed: 'Bevestigd',
    pending: 'In afwachting',
    event: 'Evenement',
    book: 'Boeken',
    min: 'min',
    filteringByCoach: 'Sessies van',
  },

  // Timing
  timing: {
    today: 'Vandaag',
    tomorrow: 'Morgen',
    thisWeek: 'Deze week',
    thisWeekend: 'Dit weekend',
    all: 'Alle',
    filterByDate: 'Filteren op datum',
    inMinutes: 'Over {{min}} min',
    inOneHour: 'Over 1u{{min}}',
    inHours: 'Over {{hours}}u{{min}}',
  },

  levels: {
    all: 'Alle niveaus',
    debutant: 'Beginner',
    intermediaire: 'Gemiddeld',
    avance: 'Gevorderd',
    tous: 'Alle niveaus',
  },

  objectives: {
    douceur: 'Rustig herbeginnen',
    douceurDesc: 'Zachte activiteiten om met een gerust hart opnieuw te sporten',
    regulier: 'Regelmatig bewegen',
    regulierDesc: 'Een gevarieerde mix voor een evenwichtige routine',
    challenge: 'Mezelf uitdagen',
    challengeDesc: 'Intensieve sessies om je grenzen te verleggen',
    jeune: 'Jong vooruitgaan',
    jeuneDesc: 'Energie en dynamiek voor de meest gemotiveerden',
    senior: 'Actief blijven 50+',
    seniorDesc: 'Aangepaste activiteiten voor duurzame fitheid',
    clickToChange: 'Klik om te wijzigen',
  },

  onboarding: {
    welcome: 'Welkom bij Motivya!',
    welcomeDesc: 'Vind sportactiviteiten bij jou in de buurt, afgestemd op jouw doelen en niveau.',
    sessionsCount: '200+ sessies',
    nearYou: 'Dichtbij jou',
    certifiedCoaches: 'Gecertificeerde coaches',
    start: 'Beginnen',
    objectiveTitle: 'Wat is jouw doel?',
    objectiveDesc: 'We personaliseren jouw aanbevelingen',
    back: 'Terug',
    discover: 'Ontdek de activiteiten',
    locating: 'Locatie bepalen...',
    locationNote: 'We gebruiken je locatie om activiteiten bij jou in de buurt te vinden',
  },

  coach: {
    noRiskModel: 'Risicovrij model',
    heroTitle1: 'Genereer een regelmatig inkomen.',
    heroTitle2: 'Zonder risico. Zonder zaal.',
    heroSub1: 'Jij bepaalt je prijs. Jij bepaalt je minimumdrempel.',
    heroSub2: 'De les start pas als die rendabel is.',
    simulateRevenue: 'Simuleer mijn inkomen',
    createProfile: 'Maak mijn coachprofiel',
    keyPrinciple: 'Kernprincipe',
    neverAtLoss: 'Nooit verlies.',
    neverAtLossDesc: 'Het concept dat alles verandert voor zelfstandige coaches',
    defineThreshold: 'Bepaal je drempel',
    defineThresholdDesc: 'Jij kiest het minimale aantal deelnemers (bijv: 4 personen) zodat de sessie rendabel is.',
    thresholdReached: 'Drempel bereikt = Sessie bevestigd',
    thresholdReachedDesc: 'Als het minimum bereikt is, wordt de sessie automatisch bevestigd. Je geeft les, je verdient.',
    thresholdNotReached: 'Drempel niet bereikt = Automatisch geannuleerd',
    thresholdNotReachedDesc: 'Niet genoeg inschrijvingen? De sessie wordt automatisch geannuleerd. Deelnemers worden terugbetaald. Je hoeft je niet te verplaatsen.',
    zeroLoss: 'Gegarandeerd geen verlies',
    zeroLossDesc: 'Geen nutteloze verplaatsingen. Geen verliesgevende les. Je tijd en energie zijn beschermd.',
    concreteExample: 'Concreet voorbeeld',
    pricePerParticipant: 'Prijs per deelnemer',
    minThreshold: 'Minimumdrempel',
    participants: 'deelnemers',
    grossRevenue: 'Bruto-inkomen',
    yourReturn: 'Jouw aanvullend inkomen',
    guaranteedSession: 'Gegarandeerd rendabele sessie',
    returnRange: 'tussen 42€ en 54€ afhankelijk van je Motivya-status',
    calculateReturn: 'Bereken jouw aanvullend inkomen',
    adjustParams: 'Pas de parameters aan en kies je plan om je inkomsten na commissie te zien',
    revenueSimulator: 'Inkomstensimulator',
    estimateReturn: 'Schat je maandelijks aanvullend inkomen',
    pricePerPerson: 'Prijs per deelnemer',
    minParticipants: 'Minimaal aantal deelnemers',
    avgParticipants: 'Gemiddeld aantal deelnemers per sessie',
    sessionsPerMonth: 'Sessies per maand',
    plan: 'Plan',
    commission: 'commissie',
    monthlySubscription: 'Maandabonnement',
    guaranteed: 'INDICATIEF MINIMUMINKOMEN',
    average: 'GEMIDDELD INKOMEN',
    potential: 'POTENTIEEL INKOMEN',
    minMonth: 'indicatief/maand',
    estMonth: 'geschat/maand',
    optMonth: 'geoptimaliseerd/maand',
    calcDetail: 'Detail berekening (gemiddeld inkomen):',
    grossRev: 'Bruto-inkomen',
    paymentFees: 'Betalingskosten (1,5%)',
    commissionMotivya: 'Commissie Motivya',
    subscription: 'Abonnement',
    complementaryReturn: 'Aanvullend inkomen',
    paymentNote: 'Betalingskosten: Stripe, PayPal, Bancontact (1,5%)',
    chooseFormula: 'Kies je formule',
    pricingTitle: 'Tarieven op maat van jouw activiteit',
    pricingDesc: 'Hoe meer je inzet, hoe minder commissie je betaalt',
    popular: 'POPULAIR',
    month: '/maand',
    selected: '✓ Geselecteerd',
    subscribeTo: 'Abonneer op',
    entrepreneurTitle: 'Beheer je activiteit als een ondernemer',
    entrepreneurDesc: 'Alle tools om je coachingbusiness te ontwikkelen',
    setPrices: 'Bepaal je prijzen',
    setPricesDesc: 'Jij beslist je tarieven op basis van je ervaring en je markt',
    chooseLocations: 'Kies je locaties',
    chooseLocationsDesc: 'Parken, stranden, openbare ruimtes... Geef les waar je wilt',
    profitThreshold: 'Rendabiliteitsdrempel',
    profitThresholdDesc: 'Bepaal het minimum aantal deelnemers per sessie',
    securePayment: 'Veilige betaling',
    securePaymentDesc: 'Deelnemers betalen vooraf. Je wordt automatisch betaald',
    totalFlexibility: 'Totale flexibiliteit',
    totalFlexibilityDesc: 'Maak, wijzig of annuleer je sessies met een paar klikken',
    zeroAdmin: 'Geen administratie',
    zeroAdminDesc: 'Facturatie, terugbetalingen, meldingen... alles is geautomatiseerd',
    quote: '"Jij geeft les. Motivya garandeert je rendabiliteit."',
    readyTitle: 'Klaar om je activiteit risicovrij te ontwikkelen?',
    readyDesc: 'Sluit je aan bij de coaches die kozen voor financiële zekerheid',
    alreadyCoach: 'Je bent al coach!',
    accessDashboard: 'Ga naar je dashboard om je sessies te beheren',
    goToDashboard: 'Naar coach dashboard',
    applicationPending: 'Kandidatuur in behandeling',
    applicationPendingDesc: 'Je kandidatuur is succesvol ingediend! Het Motivya-team bekijkt ze momenteel en neemt binnenkort contact met je op.',
    processingTime: 'Gebruikelijke verwerkingstijd: 24-48 werkuren',
    backHome: 'Terug naar start',
    applicationRejected: 'Kandidatuur niet weerhouden',
    applicationRejectedDesc: 'Helaas is je kandidatuur deze keer niet weerhouden.',
    rejectionReason: 'Reden:',
    reapplyNote: 'Je kunt na 30 dagen een nieuwe kandidatuur indienen.',
    applicationTitle: 'Coach Kandidatuur',
    step: 'Stap',
    contactInfo: 'Contactgegevens',
    contactInfoDesc: 'Hoe kunnen we je bereiken?',
    profilePhoto: 'Profielfoto',
    uploadPhoto: 'Foto uploaden',
    photoHint: 'JPG of PNG, max 5MB. Je foto verschijnt op je profiel.',
    photoUploaded: 'Foto succesvol geüpload!',
    photoUploadError: 'Fout bij het uploaden van de foto',
    photoInvalidType: 'Selecteer een afbeelding (JPG, PNG)',
    photoTooLarge: 'Foto mag niet groter zijn dan 5MB',
    phone: 'Telefoon',
    professionalEmail: 'Professionele e-mail',
    mainLocation: 'Hoofdlocatie',
    linkedin: 'LinkedIn-profiel',
    website: 'Website',
    continue: 'Verder',
    proProfile: 'Professioneel profiel',
    proProfileDesc: 'Vertel ons over je ervaring',
    presentation: 'Jouw voorstelling',
    presentationPlaceholder: 'Beschrijf je parcours, je aanpak en wat jou onderscheidt...',
    experienceYears: 'Jaren ervaring',
    specialties: 'Specialiteiten',
    selectOneMin: '(selecteer minstens één)',
    certifications: 'Certificaten / Diploma\'s',
    addCertification: '+ Certificaat toevoegen',
    motivationTitle: 'Jouw motivatie',
    lastStep: 'Laatste stap voor indiening',
    whyJoin: 'Waarom wil je bij Motivya?',
    motivationPlaceholder: 'Vertel over je motivatie, je doelen en wat je van het platform verwacht...',
    summary: 'Samenvatting',
    location: 'Locatie',
    experience: 'Ervaring',
    years: 'jaar',
    chosenPlan: 'Gekozen plan',
    submitting: 'Bezig met verzenden...',
    submit: 'Kandidatuur indienen',
    submitDisclaimer: 'Door dit formulier in te dienen, geef je toestemming dat je gegevens door het Motivya-team worden bekeken.',
    applicationSent: 'Kandidatuur verzonden!',
    applicationSentDesc: 'Bedankt! Het Motivya-team bekijkt je kandidatuur binnen 24-48u en neemt contact op via e-mail.',
    publishSessions: 'Sessies publiceren',
    manageBookings: 'Reserveringen beheren',
    securePaymentFeature: 'Veilige betaling',
    basicStats: 'Basisstatistieken',
    prioritySupport: 'Prioritaire ondersteuning',
    searchVisibility: 'Meer zichtbaarheid in zoekresultaten',
    premiumBadge: '"Premium Coach"-badge',
    advancedAnalytics: 'Geavanceerde analytics',
    startFree: 'Gratis beginnen',
    chooseActive: 'Kies Active',
    choosePremium: 'Kies Premium',
    // Simulator lock
    simulatorLocked: 'Simulator vergrendeld',
    simulatorLockedDesc: 'Maak een gratis account aan om toegang te krijgen tot de inkomstensimulator en ontdek je verdienpotentieel.',
    simulatorLockedDescCoach: 'De simulator is voorbehouden aan gevalideerde coaches. Schrijf je in en boek je validatiegesprek.',
    createAccount: 'Gratis account aanmaken',
    alreadyHaveAccount: 'Al een account?',
    iAmCoach: 'Ik ben coach',
    iAmPractitioner: 'Ik ben beoefenaar',
    // Simplified acquisition form
    socialProof: '+100 coaches vertrouwen ons al',
    joinCommunity: 'Word lid van de community',
    in30Seconds: 'In 3 klikken, boek je validatiegesprek',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    email: 'E-mail',
    bookValidationCall: 'Boek mijn validatiegesprek',
    call10min: 'Gesprek van 10 min met ons team',
    profileValidation: 'Validatie van je coachprofiel',
    fullAccess: 'Toegang tot je volledige coachruimte',
    alreadyAccount: 'Al geregistreerd?',
    loginHere: 'Log in',
    thankYou: 'Bedankt!',
    bookCallNow: 'Boek nu je validatiegesprek met ons team.',
    bookMyCall: 'Boek mijn gesprek',
    calendlyNote: 'Je wordt doorgestuurd naar Calendly',
    fillAllFields: 'Vul alle velden in',
    invalidEmail: 'Ongeldig e-mailadres',
    leadSaved: 'Informatie opgeslagen!',
    // Ambassador page
    launchInProgress: 'Lancering bezig',
    foundingCoachTitle: 'Word een van de 90 oprichters-coaches in Brussel',
    foundingCoachSubtitle: 'Word ambassadeur en geniet van exclusieve levenslange voordelen',
    becomeAmbassador: 'Word ambassadeur-coach',
    alreadyJoined: 'Al {count} coaches hebben zich aangesloten',
    joinAdventure: 'Maak deel uit van het avontuur als ambassadeur',
    opportunityTitle: 'Wie eerst komt, eerst maalt',
    opportunityDesc: 'De eerste 90 coaches die Motivya in Brussel vervoegen krijgen de status van Oprichter-Coach met exclusieve levenslange voordelen.',
    noRiskTitle: 'Nooit met verlies',
    noRiskDesc: 'Jij bepaalt je minimumdrempel. Als deze niet wordt bereikt, wordt de sessie automatisch geannuleerd.',
    commissionDivided: 'Commissie ÷ 2',
    whileActive: 'Zolang je actief bent (exclusief Freemium)',
    founderBadge: 'Oprichter-Coach Badge',
    badgeForLife: 'Levenslang weergegeven op je profiel',
    priorityVisibility: 'Prioritaire zichtbaarheid',
    topSearchResults: 'Bovenaan zoekresultaten',
    earlyAccess: 'Vroege toegang',
    newFeatures: 'Tot nieuwe functies',
    productInfluence: 'Productinvloed',
    participateDecisions: 'Neem deel aan beslissingen',
    guaranteedReturn: '100% gegarandeerde terugkeer',
    autoAdjust: 'Je abonnementskeuze past zich automatisch aan om je activiteit te optimaliseren.',
    autoUpgrade: 'Als het Premium-abonnement voordeliger voor je wordt, passen we automatisch je facturatie aan zodat je altijd beloond wordt voor je prestaties.',
    noPrePayment: 'Geen vooruitbetaling van abonnement als ambassadeur, kosten worden afgehouden bij je eerste factuur. Nul risico.',
    readyGo: 'Ready? Go...',
    howItWorks: 'Hoe werkt het',
    step1Title: 'Maak je profiel aan',
    step1Desc: 'Registreer en vul je coachprofiel in 5 minuten in',
    step2Title: 'Publiceer je sessies',
    step2Desc: 'Maak activiteiten aan met je prijzen en minimumdrempel',
    step3Title: 'Ontvang je deelnemers',
    step3Desc: 'Motivya promoot je sessies en beheert inschrijvingen automatisch',
    limitedOffer: 'Beperkt aanbod',
    ambassadorSpots: '90 ambassadeursplaatsen voor Brussel',
    commissionHalved: 'commissie gehalveerd',
    freemiumStays: 'Freemium blijft op 30% ongewijzigd.',
    plusPaymentFees: '(+ 1,5% betalingskosten)',
    reserveSpot: 'Reserveer mijn ambassadeursplaats',
    takeAdvantage: 'Neem een voorsprong',
    rightNow: 'nu meteen',
    joinCoaches: 'Sluit je aan bij de {count} coaches die al hun plaats hebben gereserveerd',
    spotsRemaining: 'Sluit je aan bij de {remaining} resterende plaatsen',
    createYourProfile: 'Maak je profiel aan',
    ambassadorProgram: 'Coach Ambassadeur Programma',
    journeySimulator: 'Interactieve Simulator',
    liveExperience: 'Beleef de coach-ervaring',
    discoverIn30s: 'Ontdek hoe Motivya werkt in 3 klikken',
    createTestSession: 'Maak een testsessie aan',
    clickToSeeMagic: 'Klik om de magie te zien ✨',
    creation: 'Aanmaak',
    promotion: 'Promotie',
    reservations: 'Boekingen',
    thresholdReachedStep: 'Drempel bereikt',
    payment: 'Betaling',
    sessionCreated: '✨ Sessie aangemaakt!',
    promotionInProgress: '📣 Promotie bezig...',
    promotingSession: 'Motivya verspreidt je sessie naar lokale sporters',
    registrationsArriving: '👥 Inschrijvingen komen binnen!',
    minThreshold: 'Minimumdrempel: {count} deelnemers',
    thresholdReached: '🎉 Drempel bereikt!',
    sessionConfirmed: 'Je sessie is bevestigd',
    participantsRegistered: '{count} deelnemers ingeschreven',
    didNothing: '❤️ Je hoefde niets te doen!',
    paymentReceived: '💰 Betaling ontvangen!',
    coachActive: 'Active Coach',
    coachAmbassador: 'Ambassadeur Coach',
    asAmbassador: 'als ambassadeur',
    invoicesGenerated: 'Facturen automatisch gegenereerd',
    replayDemo: 'Demo opnieuw afspelen',
    sessionBooked: 'Sessie geboekt. Sessie gegeven. Sessie betaald.',
    focusOnPassion: 'Focus op je passie, Motivya regelt de rest.',
    exVAT: 'Excl. BTW',
    commissionMotivya: 'Motivya commissie',
    transactionFees: 'Transactiekosten',
    transactionFeesNote: '(indicatief, geoptimaliseerd op basis van beschikbare betaalmethoden)',
    // Additional keys for full translation
    reservedSpots: 'Gereserveerde plaatsen',
    simulateRevenue: 'Simuleer je inkomsten in 3 klikken',
    adjustParameters: 'Pas de parameters aan volgens je activiteit',
    pricePerParticipant: 'Prijs per deelnemer',
    minThresholdLabel: 'Minimale deelnemersdrempel',
    sessionsPerMonth: 'Sessies per maand',
    monthlyNetRevenue: 'Maandelijks extra inkomen',
    yearlyProjection: 'Jaarlijkse projectie',
    grossRevenue: 'Bruto inkomen',
    grossRevenueTVAC: 'Bruto inkomen incl. BTW',
    yourAdditionalRevenue: 'Uw extra inkomsten',
    yourAdditionalRevenueTVAC: 'Uw extra inkomsten incl. BTW',
    recommendedPlan: 'Aanbevolen formule',
    bestForYourActivity: 'optimaal voor uw activiteit',
    regularLabel: 'Standaard',
    motivyaCommission: 'Motivya commissie',
    paymentFees: 'Transactiekosten',
    subscription: 'Abonnement',
    yourNetRevenue: 'Je extra inkomen',
    estimationNote: 'Schatting gebaseerd op minimumdrempel bereikt voor elke sessie',
    autoAdjustTitle: 'Auto-aangepast abonnement',
    autoUpgradeTitle: 'Automatische upgrade',
    noPrePaymentTitle: 'Geen vooruitbetaling',
    popular: 'POPULAIR',
    month: 'maand',
    choosePlan: 'Kiezen',
    startFree: 'Gratis starten',
    concreteExample: 'Concreet voorbeeld',
    guaranteedProfitable: 'Gegarandeerd winstgevende sessie',
    commissionAndFees: 'Motivya commissie + 1,5% betalingskosten',
    monthlyProjection: 'Maandelijkse projectie',
    sessions: 'sessies',
    insteadOf: 'in plaats van',
    asLongAsActive: 'Zolang je actief bent',
    // Journey Simulator
    interactiveSimulator: 'Interactieve Simulator',
    liveCoachExperience: 'Beleef de coach-ervaring',
    discoverHow: 'Ontdek hoe Motivya werkt in 3 klikken',
    createTestSession: 'Maak een testsessie',
    clickMagic: 'Klik om de magie te zien ✨',
    stepCreation: 'Aanmaak',
    stepPromotion: 'Promotie',
    stepBookings: 'Boekingen',
    stepThreshold: 'Drempel bereikt',
    stepPayment: 'Betaling',
    sessionCreatedMsg: '✨ Sessie aangemaakt!',
    promotionInProgressMsg: '📣 Promotie bezig...',
    motivyaBroadcasts: 'Motivya verspreidt je sessie naar sporters in je zone',
    registrationsArriving: '👥 Inschrijvingen komen binnen!',
    minParticipantsRequired: 'Minimumdrempel: {count} deelnemers',
    thresholdReachedMsg: '🎉 Drempel bereikt!',
    sessionConfirmedMsg: 'Je sessie is bevestigd',
    participantsEnrolled: '{count} deelnemers ingeschreven',
    didNothingMsg: 'Je hoefde niets te doen!',
    paymentReceivedMsg: '💰 Betaling ontvangen!',
    regularCoach: 'Active Coach',
    ambassadorCoach: 'Ambassadeur Coach',
    ambassadorBadge: 'AMBASSADEUR',
    asAmbassadorBonus: 'als ambassadeur',
    invoicesAuto: 'Facturen automatisch gegenereerd',
    replayDemo: 'Demo opnieuw afspelen',
    sessionFlow: 'Sessie geboekt. Sessie gegeven. Sessie betaald.',
    focusPassion: 'Focus op je passie, Motivya regelt de rest.',
    // Hero section
    launchBadge: 'Lancering bezig',
    heroMainTitle: 'Word een van de',
    heroFoundingCoaches: '90 oprichters-coaches',
    heroInBrussels: 'in Brussel',
    heroSubtitle: 'Genereer regelmatige inkomsten.',
    heroSubtitleBold: 'Zonder risico. Zonder zaal.',
    // Opportunity section
    opportunitySectionTitle: 'Een kans voorbehouden aan de',
    opportunityFirstCoaches: 'eerste coaches',
    opportunityDesc: 'De eerste coaches pakken de beste tijdslots en de beste klanten',
    maxVisibility: 'Maximale zichtbaarheid',
    maxVisibilityDesc: 'Vanaf de lancering sta je in de frontlinie',
    priorityAccess: 'Prioritaire toegang',
    priorityAccessDesc: 'De eerste klanten zijn voor jou',
    localDomination: 'Lokale dominantie',
    localDominationDesc: 'Word DE referentie in jouw buurt',
    // No risk model section
    uniqueModel: 'Uniek model',
    noLossTitle: 'Het enige model waar je',
    noLossHighlight: 'nooit verliest',
    defineThreshold: 'Bepaal je drempel',
    defineThresholdDesc: 'Jij bepaalt het minimale aantal deelnemers vereist',
    thresholdReached: 'Drempel bereikt = Sessie bevestigd',
    thresholdReachedDesc: 'Je wordt betaald, je deelnemers zijn bevestigd',
    thresholdNotReached: 'Drempel niet bereikt = Auto annulering',
    thresholdNotReachedDesc: 'Geen kosten, geen nutteloze verplaatsing',
    zeroLoss: 'Nul verlies',
    zeroLossDesc: 'Je geeft nooit een sessie met verlies',
    exampleTitle: 'Concreet voorbeeld',
    pricePerPart: 'Prijs per deelnemer',
    minThreshold: 'Minimumdrempel',
    grossRev: 'Bruto inkomen',
    commissionRange: 'Commissie (10-30%)',
    paymentFeesEx: 'Betalingskosten (1,5%)',
    yourNetIncome: 'Je extra inkomen',
    guaranteedProfitableSession: 'Gegarandeerd winstgevende sessie',
    monthlyProjectionLabel: 'Maandelijkse projectie (12 sessies)',
    // Ambassador section
    exclusiveLaunch: 'Exclusief lancering',
    ambassadorStatus: 'Status',
    coachAmbassadorTitle: 'Coach Ambassadeur',
    noRiskAdvantage: 'Je neemt geen risico. Je neemt een voorsprong.',
    // How it works section
    howItWorksTitle: 'Hoe werkt het?',
    step1Title: 'Maak je profiel aan',
    step1Desc: 'In 2 minuten, presenteer je specialiteiten en ervaring',
    step2Title: 'Publiceer je sessies',
    step2Desc: 'Bepaal locatie, tijd, prijs en minimumdrempel',
    step3Title: 'Ontvang je deelnemers',
    step3Desc: 'Boekingen komen binnen, je wordt automatisch betaald',
    // Pricing section
    choosePlanTitle: 'Kies je formule',
    ambassadorAdvantages: 'Ambassadeur coaches',
    exclusiveAdvantages: 'genieten van exclusieve voordelen',
    // Urgency section
    limitedOfferBadge: 'Beperkt aanbod',
    ambassadorSpotsTitle: '90 ambassadeursplaatsen voor Brussel',
    whileActive: 'Zolang je actief bent',
    commissionHalvedBenefit: 'commissie gehalveerd',
    freemiumUnchanged: 'Freemium blijft op 30% ongewijzigd.',
    paymentFeesNote: '(+ betalingskosten 1,5%)',
    noAmbassadorFreemium: 'Het Ambassadeur-programma is niet beschikbaar met Freemium. Kies Active of Premium om te profiteren van verlaagde commissie.',
    howItWorksButton: 'Hoe werkt het?',
    insteadOfPercent: 'in plaats van',
    reserveAmbassadorSpot: 'Reserveer mijn ambassadeursplaats',
    // Final CTA section
    getAhead: 'Neem een voorsprong',
    rightNow: 'nu meteen',
    joinTheCoaches: 'Sluit je aan bij de {count} coaches die al hun plaats hebben gereserveerd',
    becomeAmbassadorCoach: 'Word ambassadeur-coach',
    freeSignup: 'Gratis inschrijving • Zonder verplichting • Validatie binnen 48u',
    // Form section
    createYourProfile: 'Maak je profiel aan',
    remainingSpotsJoin: 'Sluit je aan bij de {remaining} resterende plaatsen',
    // Already coach
    alreadyCoachTitle: 'Je bent al coach!',
    accessDashboard: 'Toegang tot je dashboard',
    goToDashboard: 'Naar dashboard',
    // Footer
    allRightsReserved: 'Alle rechten voorbehouden.',
    // Additional pricing keys
    publishSessions: 'Sessies publiceren',
    manageBookings: 'Boekingen beheren',
    securePaymentFeature: 'Beveiligde betaling',
    basicStats: 'Basisstatistieken',
    prioritySupport: 'Prioriteitsondersteuning',
    searchVisibility: 'Zoekzichtbaarheid boost',
    premiumBadge: 'Premium badge',
    advancedAnalytics: 'Geavanceerde statistieken',
    startFree: 'Gratis starten',
    chooseActive: 'Kies Active',
    choosePremium: 'Kies Premium',
    participants: 'deelnemers',
    commissionAndFees: 'Motivya commissie + 1,5% betalingskosten',
    // Ambassador
    ambassadorProgram: 'Ambassadeur Coach Programma',
    applicationSent: 'Je aanvraag is verzonden!',
    commission: 'Commissie',
    perSessionBonus: 'meer per sessie als ambassadeur',
    ambassadorAdvantageDesc: 'Commissie gehalveerd zolang je actief bent',
    sessions: 'sessies',
    year: 'jaar',
    // LaunchCounter
    alreadyJoined: '{count} coaches zijn al toegetreden',
  },

  session: {
    bookNow: 'Nu boeken',
    viewDetails: 'Alle details bekijken',
    inviteFriends: 'Vrienden uitnodigen',
    spotsLeft: 'plaatsen vrij',
    full: 'Volzet',
    duration: 'Duur',
    price: 'Prijs',
    location: 'Locatie',
    date: 'Datum',
    time: 'Tijd',
    coach: 'Coach',
    level: 'Niveau',
    equipment: 'Vereiste uitrusting',
    indoor: 'Binnen',
    outdoor: 'Buiten',
  },

  common: {
    loading: 'Laden...',
    error: 'Fout',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    close: 'Sluiten',
    login: 'Inloggen',
    yes: 'Ja',
    no: 'Nee',
    back: 'Terug',
    next: 'Volgende',
    or: 'of',
    and: 'en',
    sessions: 'sessies',
    pers: 'pers.',
    min: 'min.',
  },

  dates: {
    all: 'Alle',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    thisWeek: 'Deze week',
    thisWeekend: 'Dit weekend',
  },

  admin: {
    restrictedAccess: 'Beperkte toegang',
    loginToAccess: 'Log in om toegang te krijgen tot het beheer',
    login: 'Inloggen',
    administration: 'Beheer',
    loggedIn: 'Ingelogd:',
    coachApplications: 'Coach Kandidaturen',
    manageApplications: 'Beheer de coachkandidaturen op Motivya',
    pending: 'In afwachting',
    approved: 'Goedgekeurd',
    rejected: 'Afgewezen',
    all: 'Alle',
    noApplications: 'Geen kandidaturen',
    noApplicationsPending: 'Geen kandidaturen in afwachting',
    noApplicationsApproved: 'Geen goedgekeurde kandidaturen',
    noApplicationsRejected: 'Geen afgewezen kandidaturen',
    submittedOn: 'Ingediend op',
    yearsExp: 'jaar ervaring',
    website: 'Website',
    details: 'Details',
    approve: 'Goedkeuren',
    reject: 'Afwijzen',
    rejectionReason: 'Reden van afwijzing',
    applicationDetails: 'Details van de kandidatuur',
    personalInfo: 'Persoonlijke gegevens',
    fullName: 'Volledige naam',
    email: 'E-mail',
    professionalEmail: 'Professionele e-mail',
    phone: 'Telefoon',
    locationLabel: 'Locatie',
    externalLinks: 'Externe links',
    linkedinProfile: 'LinkedIn-profiel',
    professionalProfile: 'Professioneel profiel',
    yearsOfExperience: 'Jaren ervaring',
    years: 'jaar',
    bio: 'Bio',
    specialties: 'Specialiteiten',
    certifications: 'Certificaten & Diploma\'s',
    motivation: 'Motivatie',
    submittedAt: 'Ingediend op:',
    reviewedAt: 'Beoordeeld op:',
    rejectApplication: 'Deze kandidatuur afwijzen',
    rejectionPlaceholder: 'Geef de reden voor afwijzing op (verplicht)...',
    confirmReject: 'Afwijzing bevestigen',
    close: 'Sluiten',
    toastUnauthorized: 'Ongeautoriseerde toegang',
    toastLoadError: 'Fout bij het laden van kandidaturen',
    toastApproved: 'Kandidatuur goedgekeurd! De coach is op de hoogte gebracht.',
    toastApproveError: 'Fout bij het goedkeuren',
    toastRejectReasonRequired: 'Geef een reden voor afwijzing op',
    toastRejected: 'Kandidatuur afgewezen. De kandidaat is op de hoogte gebracht.',
    toastRejectError: 'Fout bij het afwijzen',
  },

  dashboard: {
    explore: 'Ontdekken',
    favorites: 'Favorieten',
    admin: 'Admin',
    profile: 'Profiel',
    hello: 'Hallo,',
    subtitle: 'Beheer je boekingen en ontdek nieuwe activiteiten',
    findActivity: 'Vind een activiteit',
    findActivityDesc: 'Ontdek sessies bij jou in de buurt',
    myFavorites: 'Mijn favorieten',
    savedSessions: 'Opgeslagen sessies',
    myProfile: 'Mijn profiel',
    myProfileDesc: 'Beheer je persoonlijke gegevens',
    nearMe: 'Activiteiten in de buurt',
    geolocated: 'Gelokaliseerd',
    filters: 'Filters',
    hide: 'Verbergen',
    show: 'Tonen',
    category: 'Categorie',
    searchRadius: 'Zoekradius:',
    sessionsFound: 'sessies gevonden',
    inCategory: 'in',
    withinRadius: 'binnen een straal van',
    reset: 'Resetten',
    locating: 'Je positie zoeken...',
    youAreHere: 'Je bent hier',
    sessionsAt: 'sessies op',
    viewAll: 'Alles bekijken',
    upcomingSessions: 'Mijn volgende sessies',
    noUpcoming: 'Geen aankomende boekingen',
    findNext: 'Vind je volgende activiteit!',
    exploreSessions: 'Sessies ontdekken',
    confirmed: 'Bevestigd',
    sessionValidated: 'Sessie bevestigd',
    spotLeft: 'plaats vrij',
    spotsLeft: 'plaatsen vrij',
    viewDetails: 'Details bekijken',
    history: 'Geschiedenis',
    cancelled: 'Geannuleerd',
    cancelledSession: 'Geannuleerde sessie',
    refunded: 'Terugbetaald',
    cancelledBadge: 'Geannuleerd',
    toastNotifNotSupported: 'Meldingen worden niet ondersteund door je browser',
    toastNotifEnabled: 'Meldingen ingeschakeld!',
    toastNotifDenied: 'Meldingen geweigerd',
    toastNotifDisabled: 'Meldingen uitgeschakeld',
    toastNotifError: 'Fout bij het inschakelen van meldingen',
    confirmCancel: 'Weet je zeker dat je deze boeking wilt annuleren?',
    toastCancelled: 'Boeking geannuleerd',
    toastCancelError: 'Fout bij het annuleren',
    notifBody: 'Je ontvangt meldingen voor nieuwe sessies bij jou in de buurt!',
  },

  favorites: {
    loginRequired: 'Log in',
    loginToSee: 'om je favorieten te bekijken',
    login: 'Inloggen',
    title: 'Mijn Favorieten',
    sessionSaved: 'sessie opgeslagen',
    sessionsSaved: 'sessies opgeslagen',
    noFavorites: 'Geen favorieten',
    noFavoritesDesc: 'Voeg sessies toe aan je favorieten om meldingen te krijgen wanneer er plaatsen vrijkomen!',
    exploreSessions: 'Sessies ontdekken',
    available: 'Plaatsen beschikbaar',
    fullWaiting: 'Volzet - Wachtend',
    notifyWhenAvailable: 'Je wordt verwittigd zodra er een plaats vrijkomt',
    full: 'Volzet',
    spot: 'plaats',
    spots: 'plaatsen',
    bookNow: 'Nu boeken',
    notifEnabled: 'Meldingen ingeschakeld',
    notifDisabled: 'Meldingen uitgeschakeld',
    removeFromFavorites: 'Uit favorieten verwijderen',
    toastRemoved: 'Uit favorieten verwijderd',
    toastRemoveError: 'Fout bij het verwijderen',
    toastLoadError: 'Fout bij het laden van favorieten',
    toastUpdateError: 'Fout bij het bijwerken',
  },

  profile: {
    title: 'Mijn Profiel',
    subtitle: 'Beheer je persoonlijke gegevens',
    coach: 'Coach',
    practitioner: 'Beoefenaar',
    info: 'Gegevens',
    fullName: 'Volledige naam',
    phone: 'Telefoon',
    city: 'Stad',
    cityPlaceholder: 'Bijv: Brussel',
    becomeCoach: 'Word Coach',
    becomeCoachDesc: 'Ben je sportcoach? Sluit je aan bij onze community en bied je sessies aan.',
    learnMore: 'Meer weten',
    save: 'Opslaan',
    toastSaved: 'Profiel bijgewerkt!',
    toastSaveError: 'Fout bij het bijwerken van profiel',
    clickToChangePhoto: 'Klik op de foto om te wijzigen',
    photoUploaded: 'Foto geüpload!',
    photoUploadError: 'Fout bij uploaden foto',
    photoInvalidType: 'Ongeldig formaat. Gebruik JPEG, PNG of WebP.',
    photoTooLarge: 'Foto te groot. Maximum 5MB.',
  },

  coachDash: {
    calendar: 'Kalender',
    hello: 'Hallo,',
    coachSpace: 'Jouw Motivya coach-ruimte',
    newSession: 'Nieuwe sessie',
    total: 'Totaal',
    sessionsCreated: 'Sessies aangemaakt',
    upcoming: 'Aankomend',
    bookings: 'Boekingen',
    totalRevenue: 'Totale inkomsten',
    createSession: 'Sessie aanmaken',
    publishActivity: 'Publiceer een nieuwe activiteit',
    myCalendar: 'Mijn kalender',
    managePlanning: 'Beheer je planning',
    myProfile: 'Mijn profiel',
    optimizeVisibility: 'Optimaliseer je zichtbaarheid',
    recentSessions: 'Recente sessies',
    viewAll: 'Alles bekijken →',
    noSessions: 'Geen sessies aangemaakt',
    startFirst: 'Begin met het aanmaken van je eerste sessie',
    confirmed: 'Bevestigd',
    pending: 'In afwachting',
    event: 'Evenement',
    participants: 'deelnemers',
    edit: 'Bewerken',
    expiredSessions: 'Verlopen sessies',
    noExpired: 'Geen verlopen sessies',
    noRevenue: 'Geen inkomsten',
  },

  coachCal: {
    dashboard: 'Dashboard',
    title: 'Mijn Kalender',
    subtitle: 'Beheer je geplande sessies',
    newSession: 'Nieuwe sessie',
    dayWithSession: 'Dag met sessie(s)',
    noSessionDay: 'Geen sessies vandaag',
    createForDate: 'Maak een nieuwe sessie aan voor deze datum',
    createSession: 'Sessie aanmaken',
    confirmed: 'Bevestigd',
    cancelled: 'Geannuleerd',
    pending: 'In afwachting',
    edit: 'Bewerken',
    allSessions: 'Al mijn sessies',
    noSessions: 'Geen sessies aangemaakt',
  },

  createSession: {
    title: 'Nieuwe Sessie',
    sessionType: 'Type sessie',
    regular: 'Reguliere sessie',
    regularDesc: 'Terugkerende activiteit met herhalingsoptie',
    uniqueEvent: 'Uniek evenement',
    uniqueEventDesc: 'Eenmalige sessie, workshop of masterclass',
    generalInfo: 'Algemene informatie',
    sessionTitle: 'Titel van de sessie *',
    titlePlaceholder: 'Bijv: Ochtend Vinyasa Yoga Flow',
    description: 'Beschrijving *',
    descriptionPlaceholder: 'Beschrijf je sessie, het verloop, wat deelnemers zullen leren...',
    category: 'Categorie *',
    select: 'Selecteren',
    level: 'Niveau *',
    dateTime: 'Datum en tijd',
    startDate: 'Startdatum *',
    startTime: 'Starttijd *',
    duration: 'Duur *',
    recurrence: 'Herhaling',
    unique: 'Eenmalig',
    once: 'Slechts één keer',
    daily: 'Dagelijks',
    everyDay: 'Elke dag',
    weekly: 'Wekelijks',
    everyWeek: 'Elke week',
    monthly: 'Maandelijks',
    everyMonth: 'Elke maand',
    occurrences: 'Aantal herhalingen',
    sessionsWillBeCreated: 'sessies worden aangemaakt',
    consecutiveDays: 'opeenvolgende dagen',
    weeks: 'weken',
    months: 'maanden',
    location: 'Locatie',
    searchAddress: 'Zoek een adres',
    addressPlaceholder: 'Bijv: Jubelpark, Brussel',
    locationSelected: 'Locatie geselecteerd',
    mapHint: 'Klik op de kaart of sleep de markering om de positie aan te passen',
    indoor: 'Binnensessie',
    indoorDesc: 'Schakel in als de sessie binnenshuis plaatsvindt',
    participantsAndPricing: 'Deelnemers en tarief',
    minimum: 'Minimum *',
    maximum: 'Maximum *',
    price: 'Prijs (€) *',
    confirmationThreshold: 'Bevestigingsdrempel',
    equipment: 'Benodigde uitrusting (optioneel)',
    equipmentPlaceholder: 'Bijv: Yogamat, waterfles',
    cancel: 'Annuleren',
    createSessionBtn: 'Sessie aanmaken',
    createMultiple: '{{count}} sessies aanmaken',
    toastDateRequired: 'Selecteer een datum',
    toastCategoryRequired: 'Selecteer een categorie',
    toastLocationRequired: 'Stel een locatie in',
    toastCreatedMultiple: '{{count}} sessies succesvol aangemaakt!',
    toastCreated: 'Sessie succesvol aangemaakt!',
    toastError: 'Fout bij het aanmaken',
    dur30: '30 minuten',
    dur45: '45 minuten',
    dur60: '1 uur',
    dur90: '1u30',
    dur120: '2 uur',
  },

  editSession: {
    title: 'Sessie bewerken',
    generalInfo: 'Algemene informatie',
    sessionTitle: 'Titel van de sessie *',
    description: 'Beschrijving *',
    category: 'Categorie *',
    level: 'Niveau *',
    dateTime: 'Datum en tijd',
    date: 'Datum *',
    startTime: 'Starttijd *',
    duration: 'Duur',
    location: 'Locatie',
    address: 'Adres / Locatie *',
    indoor: 'Binnensessie',
    participantsAndPricing: 'Deelnemers en tarief',
    minParticipants: 'Minimum deelnemers',
    maxParticipants: 'Maximum deelnemers',
    pricePerPerson: 'Prijs per persoon (€)',
    equipment: 'Benodigde uitrusting',
    cancelSession: 'Sessie annuleren',
    back: 'Terug',
    save: 'Opslaan',
    confirmed: 'Bevestigd',
    cancelled: 'Geannuleerd',
    pending: 'In afwachting',
    participants: 'deelnemers',
    viewPage: 'Pagina bekijken',
    enrolledParticipants: 'Ingeschreven deelnemers',
    user: 'Gebruiker',
    select: 'Selecteren',
    toastNotFound: 'Sessie niet gevonden',
    toastLoadError: 'Laadfout',
    toastUpdated: 'Sessie bijgewerkt!',
    toastUpdateError: 'Fout bij het bijwerken',
    confirmDelete: 'Weet je zeker dat je deze sessie wilt annuleren? Alle deelnemers worden terugbetaald.',
    toastDeleted: 'Sessie geannuleerd',
    toastDeleteError: 'Fout bij het annuleren',
    dur30: '30 minuten',
    dur45: '45 minuten',
    dur60: '1 uur',
    dur90: '1u30',
    dur120: '2 uur',
  },

  sessionDetail: {
    title: 'Sessiedetails',
    indoor: 'Binnen',
    outdoor: 'Buiten',
    practicalInfo: 'Praktische informatie',
    minutes: 'minuten',
    viewOnMap: 'Bekijk op kaart →',
    participants: 'deelnemers',
    spotsLeft: 'plaats(en) vrij',
    full: 'Volzet',
    minRequired: 'Minimum {{count}} deelnemers vereist',
    equipment: 'Mee te brengen materiaal',
    yourCoach: 'Jouw Coach',
    yearsExperience: 'jaar ervaring',
    perPerson: 'per persoon',
    sessionConfirmed: 'Sessie bevestigd',
    waitingParticipants: 'In afwachting van deelnemers',
    youAreEnrolled: 'Je bent ingeschreven!',
    viewBookings: 'Mijn boekingen bekijken →',
    bookNow: 'Nu boeken',
    moreFunTogether: 'Leuker met vrienden!',
    securePayment: 'Veilige betaling - Gratis annulering',
    loginToBook: 'om deze sessie te boeken',
    toastNotFound: 'Sessie niet gevonden',
    toastLoadError: 'Fout bij het laden',
    toastLoginRequired: 'Log in om te boeken',
    toastCoachCannotBook: 'Coaches kunnen geen sessies boeken',
    toastBooked: 'Boeking bevestigd! (Gesimuleerde betaling)',
    toastBookError: 'Fout bij het boeken',
  },

  coachProfile: {
    title: 'Mijn Coachprofiel',
    subtitle: 'Vul je profiel aan om meer deelnemers aan te trekken',
    fullName: 'Volledige naam',
    phone: 'Telefoon',
    presentation: 'Presentatie',
    bio: 'Bio',
    bioPlaceholder: 'Stel jezelf voor, je achtergrond, je aanpak...',
    specialties: 'Specialiteiten',
    certifications: 'Certificaten',
    addCert: 'Toevoegen',
    certPrompt: 'Naam van het certificaat:',
    experienceAndRates: 'Ervaring en tarieven',
    yearsExperience: 'Jaren ervaring',
    hourlyRate: 'Indicatief uurtarief (€)',
    serviceArea: 'Werkgebied',
    serviceAreaPlaceholder: 'Bijv: Brussel en omgeving',
    save: 'Opslaan',
    toastSaved: 'Profiel bijgewerkt!',
    toastError: 'Fout bij het bijwerken van profiel',
  },

  auth: {
    loginTitle: 'Inloggen',
    registerTitle: 'Account aanmaken',
    email: 'E-mail',
    password: 'Wachtwoord',
    confirmPassword: 'Bevestig wachtwoord',
    name: 'Volledige naam',
    loginBtn: 'Inloggen',
    registerBtn: 'Registreren',
    googleLogin: 'Verder met Google',
    noAccount: 'Nog geen account?',
    hasAccount: 'Al een account?',
    signUp: 'Registreren',
    signIn: 'Inloggen',
    loginFirst: 'Log eerst in',
    passwordMismatch: 'Wachtwoorden komen niet overeen',
    passwordTooShort: 'Wachtwoord moet minimaal 6 tekens bevatten',
    registerSuccess: 'Registratie geslaagd!',
    completeCoachProfile: 'Vul je profiel aan om coach te worden',
    backToHome: 'Terug naar home',
    joinAs: 'Ik wil meedoen als',
    practitioner: 'Deelnemer',
    practitionerDesc: 'Ik wil deelnemen aan sportsessies',
    coachOption: 'Coach',
    coachDesc: 'Ik wil sessies aanbieden',
  },
  whatsapp: {
    inviteFriends: 'Vrienden uitnodigen',
    bookingConfirmed: 'Boeking bevestigd!',
    spotsLeftInvite: 'Nog {{count}} plaats(en) - Nodig je vrienden uit!',
    shareSession: 'Deel deze sessie met je vrienden',
    shareOnWhatsApp: 'Delen op WhatsApp',
    maybeLater: 'Misschien later',
    msgBooked: 'Ik heb net een sportsessie geboekt!',
    msgSpotsLeft: 'Nog {{count}} plaats(en)! Wie komt er mee?',
    msgBookSpot: 'Boek je plek',
    copyLink: 'Link kopiëren',
    linkCopied: 'Link gekopieerd!',
    inviteTitle: 'Nodig een vriend uit',
    inviteDesc: 'Ik doe mee aan deze sportactiviteit op Motivya. Kom je mee?',
  },

  // Share (multi-platform)
  share: {
    inviteFriend: 'Vriend uitnodigen',
    shareVia: 'Delen via',
    spotsLeft: '{{count}} plaatsen over',
    spotsLeftMessage: 'Nog maar {{count}} plaats(en)!',
    bookYourSpot: 'Boek je plek',
    copied: 'Gekopieerd!',
    copyLink: 'Link kopiëren',
    justBooked: 'Ik heb net geboekt!',
    bookingConfirmed: 'Boeking bevestigd!',
    spotsLeftInvite: 'Nog {{count}} plaatsen, nodig je vrienden uit!',
    shareWithFriends: 'Deel deze sessie met je vrienden!',
    shareWhatsApp: 'Delen op WhatsApp',
    moreOptions: 'Meer opties om te delen',
    maybeLater: 'Misschien later',
  },

};

export default nl;
